import React from 'react';
import SimilarSuggestionCard from '../ext/SimilarSuggestionCard';

/** Карточка предложения бренда — обёртка над унифицированным SimilarSuggestionCard */
const SuggestionCard = ({ suggestion, onToggleLock }) => (
  <SimilarSuggestionCard variant="brand" item={suggestion} onToggleLock={onToggleLock} />
);

export default SuggestionCard;
